// 보호구 마스터 목록 (안전작업허가서 WorkPermit.vue의 protectionOptions와 동일).
// 일일작업허가서 보호구 선택 모달과 부모 데이터 집계에서 공유한다.
export const PROTECTION_OPTIONS = [
  { key: '머리|안전모', category: '머리', name: '안전모' },
  { key: '눈|보안경', category: '눈', name: '보안경' },
  { key: '눈|차광보안경', category: '눈', name: '차광보안경' },
  { key: '얼굴|안면보호구', category: '얼굴', name: '안면보호구' },
  { key: '귀|귀마개', category: '귀', name: '귀마개' },
  { key: '귀|귀덮개', category: '귀', name: '귀덮개' },
  { key: '호흡기|방진마스크', category: '호흡기', name: '방진마스크' },
  { key: '호흡기|방독마스크', category: '호흡기', name: '방독마스크' },
  { key: '호흡기|송기마스크', category: '호흡기', name: '송기마스크' },
  { key: '호흡기|공기호흡기', category: '호흡기', name: '공기호흡기' },
  { key: '손|안전장갑', category: '손', name: '안전장갑' },
  { key: '손|절연장갑', category: '손', name: '절연장갑' },
  { key: '손|내화학장갑', category: '손', name: '내화학장갑' },
  { key: '손|방열장갑', category: '손', name: '방열장갑' },
  { key: '손|절단방지장갑', category: '손', name: '절단방지장갑' },
  { key: '손|방진장갑', category: '손', name: '방진장갑' },
  { key: '발|안전화', category: '발', name: '안전화' },
  { key: '발|안전장화', category: '발', name: '안전장화' },
  { key: '발|절연화', category: '발', name: '절연화' },
  { key: '발|절연장화', category: '발', name: '절연장화' },
  { key: '몸통|작업복', category: '몸통', name: '작업복' },
  { key: '몸통|방열복', category: '몸통', name: '방열복' },
  { key: '몸통|내화학복', category: '몸통', name: '내화학복' },
  { key: '몸통|Arc suit', category: '몸통', name: 'Arc suit' },
  { key: '몸통|안전그네식 안전대', category: '몸통', name: '안전그네식 안전대' },
  { key: '몸통|벨트식 안전대', category: '몸통', name: '벨트식 안전대' }
];

// 보호구 옵션 표시 라벨 ("구분/이름")
export function protectionLabel(option) {
  if (!option) return '';
  if (typeof option === 'string') return option;
  return option.category ? `${option.category}/${option.name}` : (option.name || '');
}

// 부모 set.protection 값(string | {key,category,name} | Array)을 옵션 객체 배열로 정규화.
// 마스터 목록과 key/name으로 매칭하고, 못 찾으면 의사 옵션을 만든다.
export function toProtectionOptions(rawValue) {
  if (!rawValue) return [];
  const arr = Array.isArray(rawValue) ? rawValue : [rawValue];
  const result = [];
  arr.forEach((v) => {
    if (!v) return;
    if (typeof v === 'object') {
      const matched = PROTECTION_OPTIONS.find(
        (o) => o.key === v.key || (o.name === v.name && (!v.category || o.category === v.category))
      );
      result.push(matched || { key: v.key || v.name, category: v.category || '', name: v.name || String(v.key || '') });
      return;
    }
    const s = String(v).trim();
    if (!s) return;
    const matched = PROTECTION_OPTIONS.find(
      (o) => o.key === s || o.name === s || `${o.category}/${o.name}` === s
    );
    result.push(matched || { key: s, category: '', name: s });
  });
  return result;
}